/**
 * MessageListSkeleton - Skeleton loader for message list
 */

import React from 'react';

export const MessageListSkeleton: React.FC = () => {
  return (
    <div className="p-4 space-y-4">
      {[1, 2, 3, 4, 5].map((i) => (
        <div
          key={i}
          className={`flex ${i % 2 === 0 ? 'justify-end' : 'justify-start'} animate-pulse`}
        >
          <div className={`max-w-xs lg:max-w-md ${i % 2 === 0 ? 'bg-blue-100' : 'bg-gray-100'} rounded-lg p-3`}>
            <div className="h-4 bg-gray-300 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-gray-300 rounded w-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  );
};
